/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/time';
import './model';
import '../common';
import '../../client/status';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "rewards": {
        "nested": {
          "rewardCode": {
            "nested": {
              "service": {
                "nested": {
                  "CampaignRequest": {
                    "fields": {
                      "partnerName": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "campaignName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "rewardName": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "maxUses": {
                        "type": "int64",
                        "id": 4,
                        "rule": "optional"
                      },
                      "expiresAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 5,
                        "rule": "optional"
                      },
                      "expiresInDays": {
                        "type": "int64",
                        "id": 6,
                        "rule": "optional"
                      },
                      "currencyCode": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "grantAmount": {
                        "type": "int64",
                        "id": 8,
                        "rule": "optional"
                      },
                      "headline": {
                        "type": "string",
                        "id": 9,
                        "rule": "optional"
                      },
                      "introduction": {
                        "type": "string",
                        "id": 10,
                        "rule": "optional"
                      },
                      "finePrint1": {
                        "type": "string",
                        "id": 11,
                        "rule": "optional"
                      },
                      "finePrint2": {
                        "type": "string",
                        "id": 12,
                        "rule": "optional"
                      },
                      "imageUrl": {
                        "type": "string",
                        "id": 13,
                        "rule": "optional"
                      },
                      "createdBy": {
                        "type": "string",
                        "id": 14,
                        "rule": "optional"
                      }
                    }
                  },
                  "CampaignResponse": {
                    "fields": {
                      "status": {
                        "type": ".squareup.rewards.rewardCode.service.CampaignResponse.Status",
                        "id": 1,
                        "rule": "optional"
                      },
                      "rewardCode": {
                        "type": ".squareup.rewards.rewardCode.RewardCode",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Status": {
                        "values": {
                          "UNKNOWN": 0,
                          "SUCCESS": 1,
                          "INVALID_REQUEST": 2,
                          "FAILURE": 3
                        }
                      }
                    }
                  },
                  "ShowRequest": {
                    "fields": {
                      "rewardCode": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "languageCode": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "countryCode": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "ShowResponse": {
                    "fields": {
                      "status": {
                        "type": ".squareup.rewards.rewardCode.service.ShowResponse.Status",
                        "id": 1,
                        "rule": "optional"
                      },
                      "rewardCode": {
                        "type": ".squareup.rewards.rewardCode.RewardCode",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Status": {
                        "values": {
                          "UNKNOWN": 0,
                          "NOT_FOUND": 1,
                          "INVALID_REWARD_CODE": 2,
                          "SUCCESS": 3
                        }
                      }
                    }
                  },
                  "ClaimRequest": {
                    "fields": {
                      "rewardCode": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "receiverUnitToken": {
                        "type": "string",
                        "id": 1
                      },
                      "receiverMerchantToken": {
                        "type": "string",
                        "id": 2
                      }
                    },
                    "nested": {
                      "receiver_token": {
                        "oneof": [
                          "receiverUnitToken",
                          "receiverMerchantToken"
                        ]
                      }
                    }
                  },
                  "ClaimResponse": {
                    "fields": {
                      "status": {
                        "type": ".squareup.rewards.rewardCode.service.ClaimResponse.Status",
                        "id": 1,
                        "rule": "optional"
                      },
                      "activated": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Status": {
                        "values": {
                          "UNKNOWN": 0,
                          "INVALID_REQUEST": 1,
                          "SUCCESS": 2
                        }
                      }
                    }
                  },
                  "UnclaimRequest": {
                    "fields": {
                      "rewardName": {
                        "type": ".squareup.rewards.RewardName",
                        "id": 3,
                        "rule": "optional"
                      },
                      "rewardCode": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "receiverUnitToken": {
                        "type": "string",
                        "id": 1
                      },
                      "receiverMerchantToken": {
                        "type": "string",
                        "id": 2
                      }
                    },
                    "nested": {
                      "receiver_token": {
                        "oneof": [
                          "receiverUnitToken",
                          "receiverMerchantToken"
                        ]
                      }
                    }
                  },
                  "UnclaimResponse": {
                    "fields": {
                      "status": {
                        "type": ".squareup.rewards.rewardCode.service.UnclaimResponse.Status",
                        "id": 1,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Status": {
                        "values": {
                          "UNKNOWN": 0,
                          "NOT_FOUND": 1,
                          "SUCCESS": 2
                        }
                      }
                    }
                  },
                  "ActivateRequest": {
                    "fields": {
                      "rewardName": {
                        "type": ".squareup.rewards.RewardName",
                        "id": 3,
                        "rule": "optional"
                      },
                      "rewardCode": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "receiverUnitToken": {
                        "type": "string",
                        "id": 1
                      },
                      "receiverMerchantToken": {
                        "type": "string",
                        "id": 2
                      }
                    },
                    "nested": {
                      "receiver_token": {
                        "oneof": [
                          "receiverUnitToken",
                          "receiverMerchantToken"
                        ]
                      }
                    }
                  },
                  "ActivateResponse": {
                    "fields": {
                      "status": {
                        "type": ".squareup.rewards.rewardCode.service.ActivateResponse.Status",
                        "id": 1,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Status": {
                        "values": {
                          "UNKNOWN": 0,
                          "NOT_FOUND": 1,
                          "SUCCESS": 2,
                          "USER_NOT_ELIGIBLE": 3
                        }
                      }
                    }
                  },
                  "GetForMerchantRequest": {
                    "fields": {
                      "rewardName": {
                        "type": ".squareup.rewards.RewardName",
                        "id": 3,
                        "rule": "optional"
                      },
                      "maxUses": {
                        "type": "int64",
                        "id": 4,
                        "rule": "optional"
                      },
                      "rewardProgram": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "rewardCodePurpose": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      },
                      "senderUnitToken": {
                        "type": "string",
                        "id": 1
                      },
                      "senderMerchantToken": {
                        "type": "string",
                        "id": 2
                      }
                    },
                    "nested": {
                      "sender_token": {
                        "oneof": [
                          "senderUnitToken",
                          "senderMerchantToken"
                        ]
                      }
                    }
                  },
                  "GetForMerchantResponse": {
                    "fields": {
                      "status": {
                        "type": ".squareup.rewards.rewardCode.service.GetForMerchantResponse.Status",
                        "id": 1,
                        "rule": "optional"
                      },
                      "rewardCode": {
                        "type": ".squareup.rewards.rewardCode.RewardCode",
                        "id": 2,
                        "rule": "optional"
                      },
                      "mobileStatus": {
                        "type": ".squareup.client.Status",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Status": {
                        "values": {
                          "UNKNOWN": 0,
                          "USER_NOT_ELIGIBLE": 1,
                          "FAILURE": 2,
                          "SUCCESS": 3,
                          "INVALID_REQUEST": 4
                        }
                      }
                    }
                  },
                  "CustomizeRewardCodeRequest": {
                    "fields": {
                      "rewardCode": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "CustomizeRewardCodeResponse": {
                    "fields": {
                      "status": {
                        "type": ".squareup.rewards.rewardCode.service.CustomizeRewardCodeResponse.Status",
                        "id": 1,
                        "rule": "optional"
                      },
                      "rewardCode": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Status": {
                        "values": {
                          "FAILURE": 0,
                          "BAD_REQUEST": 1,
                          "INVALID_LENGTH": 2,
                          "INVALID_CHAR": 3,
                          "IN_USE": 4,
                          "SUCCESS": 5
                        }
                      }
                    }
                  },
                  "GetRewardCodeUsesForMerchantRequest": {
                    "fields": {
                      "merchantToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "GetRewardCodeUsesForMerchantResponse": {
                    "fields": {
                      "status": {
                        "type": ".squareup.rewards.rewardCode.service.GetRewardCodeUsesForMerchantResponse.Status",
                        "id": 1,
                        "rule": "optional"
                      },
                      "rewardCodeUses": {
                        "type": ".squareup.rewards.rewardCode.RewardCodeUse",
                        "id": 2,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "Status": {
                        "values": {
                          "UNKNOWN": 0,
                          "NOT_FOUND": 1,
                          "SUCCESS": 2
                        }
                      }
                    }
                  },
                  "RewardCodeService": {
                    "methods": {
                      "Show": {
                        "requestType": ".squareup.rewards.rewardCode.service.ShowRequest",
                        "responseType": ".squareup.rewards.rewardCode.service.ShowResponse"
                      },
                      "Claim": {
                        "requestType": ".squareup.rewards.rewardCode.service.ClaimRequest",
                        "responseType": ".squareup.rewards.rewardCode.service.ClaimResponse"
                      },
                      "Unclaim": {
                        "requestType": ".squareup.rewards.rewardCode.service.UnclaimRequest",
                        "responseType": ".squareup.rewards.rewardCode.service.UnclaimResponse"
                      },
                      "Activate": {
                        "requestType": ".squareup.rewards.rewardCode.service.ActivateRequest",
                        "responseType": ".squareup.rewards.rewardCode.service.ActivateResponse"
                      },
                      "GetForMerchant": {
                        "requestType": ".squareup.rewards.rewardCode.service.GetForMerchantRequest",
                        "responseType": ".squareup.rewards.rewardCode.service.GetForMerchantResponse"
                      },
                      "Campaign": {
                        "requestType": ".squareup.rewards.rewardCode.service.CampaignRequest",
                        "responseType": ".squareup.rewards.rewardCode.service.CampaignResponse"
                      },
                      "CustomizeRewardCode": {
                        "requestType": ".squareup.rewards.rewardCode.service.CustomizeRewardCodeRequest",
                        "responseType": ".squareup.rewards.rewardCode.service.CustomizeRewardCodeResponse"
                      },
                      "GetRewardCodeUsesForMerchant": {
                        "requestType": ".squareup.rewards.rewardCode.service.GetRewardCodeUsesForMerchantRequest",
                        "responseType": ".squareup.rewards.rewardCode.service.GetRewardCodeUsesForMerchantResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.CampaignRequest && !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.CampaignResponse && !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.CampaignResponse?.nested?.Status && !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.ShowRequest && !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.ShowResponse && !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.ShowResponse?.nested?.Status && !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.ClaimRequest && !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.ClaimResponse && !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.ClaimResponse?.nested?.Status && !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.UnclaimRequest && !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.UnclaimResponse && !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.UnclaimResponse?.nested?.Status && !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.ActivateRequest && !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.ActivateResponse && !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.ActivateResponse?.nested?.Status && !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.GetForMerchantRequest && !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.GetForMerchantResponse && !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.GetForMerchantResponse?.nested?.Status && !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.CustomizeRewardCodeRequest && !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.CustomizeRewardCodeResponse && !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.CustomizeRewardCodeResponse?.nested?.Status && !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.GetRewardCodeUsesForMerchantRequest && !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.GetRewardCodeUsesForMerchantResponse && !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.GetRewardCodeUsesForMerchantResponse?.nested?.Status && !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested?.service?.nested?.RewardCodeService) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE CampaignRequest @ squareup/rewards/rewardCode/service.proto at 44:1
 */
export const CampaignRequest = $root.lookupType('squareup.rewards.rewardCode.service.CampaignRequest');
fixType(CampaignRequest);
Builder.createAndAttachToType(CampaignRequest);
/**
 * SOURCE CampaignResponse @ squareup/rewards/rewardCode/service.proto at 61:1
 */
export const CampaignResponse = $root.lookupType('squareup.rewards.rewardCode.service.CampaignResponse');
fixType(CampaignResponse);
Builder.createAndAttachToType(CampaignResponse);
/**
 * SOURCE Status @ squareup/rewards/rewardCode/service.proto at 62:3
 */
CampaignResponse.Status = $root.lookupEnum('squareup.rewards.rewardCode.service.CampaignResponse.Status').values;
/**
 * SOURCE ShowRequest @ squareup/rewards/rewardCode/service.proto at 73:1
 */
export const ShowRequest = $root.lookupType('squareup.rewards.rewardCode.service.ShowRequest');
fixType(ShowRequest);
Builder.createAndAttachToType(ShowRequest);
/**
 * SOURCE ShowResponse @ squareup/rewards/rewardCode/service.proto at 79:1
 */
export const ShowResponse = $root.lookupType('squareup.rewards.rewardCode.service.ShowResponse');
fixType(ShowResponse);
Builder.createAndAttachToType(ShowResponse);
/**
 * SOURCE Status @ squareup/rewards/rewardCode/service.proto at 80:3
 */
ShowResponse.Status = $root.lookupEnum('squareup.rewards.rewardCode.service.ShowResponse.Status').values;
/**
 * SOURCE ClaimRequest @ squareup/rewards/rewardCode/service.proto at 96:1
 */
export const ClaimRequest = $root.lookupType('squareup.rewards.rewardCode.service.ClaimRequest');
fixType(ClaimRequest);
Builder.createAndAttachToType(ClaimRequest);
/**
 * SOURCE ClaimResponse @ squareup/rewards/rewardCode/service.proto at 105:1
 */
export const ClaimResponse = $root.lookupType('squareup.rewards.rewardCode.service.ClaimResponse');
fixType(ClaimResponse);
Builder.createAndAttachToType(ClaimResponse);
/**
 * SOURCE Status @ squareup/rewards/rewardCode/service.proto at 106:3
 */
ClaimResponse.Status = $root.lookupEnum('squareup.rewards.rewardCode.service.ClaimResponse.Status').values;
/**
 * SOURCE UnclaimRequest @ squareup/rewards/rewardCode/service.proto at 127:1
 */
export const UnclaimRequest = $root.lookupType('squareup.rewards.rewardCode.service.UnclaimRequest');
fixType(UnclaimRequest);
Builder.createAndAttachToType(UnclaimRequest);
/**
 * SOURCE UnclaimResponse @ squareup/rewards/rewardCode/service.proto at 137:1
 */
export const UnclaimResponse = $root.lookupType('squareup.rewards.rewardCode.service.UnclaimResponse');
fixType(UnclaimResponse);
Builder.createAndAttachToType(UnclaimResponse);
/**
 * SOURCE Status @ squareup/rewards/rewardCode/service.proto at 138:3
 */
UnclaimResponse.Status = $root.lookupEnum('squareup.rewards.rewardCode.service.UnclaimResponse.Status').values;
/**
 * SOURCE ActivateRequest @ squareup/rewards/rewardCode/service.proto at 152:1
 */
export const ActivateRequest = $root.lookupType('squareup.rewards.rewardCode.service.ActivateRequest');
fixType(ActivateRequest);
Builder.createAndAttachToType(ActivateRequest);
/**
 * SOURCE ActivateResponse @ squareup/rewards/rewardCode/service.proto at 162:1
 */
export const ActivateResponse = $root.lookupType('squareup.rewards.rewardCode.service.ActivateResponse');
fixType(ActivateResponse);
Builder.createAndAttachToType(ActivateResponse);
/**
 * SOURCE Status @ squareup/rewards/rewardCode/service.proto at 163:3
 */
ActivateResponse.Status = $root.lookupEnum('squareup.rewards.rewardCode.service.ActivateResponse.Status').values;
/**
 * SOURCE GetForMerchantRequest @ squareup/rewards/rewardCode/service.proto at 180:1
 */
export const GetForMerchantRequest = $root.lookupType('squareup.rewards.rewardCode.service.GetForMerchantRequest');
fixType(GetForMerchantRequest);
Builder.createAndAttachToType(GetForMerchantRequest);
/**
 * SOURCE GetForMerchantResponse @ squareup/rewards/rewardCode/service.proto at 192:1
 */
export const GetForMerchantResponse = $root.lookupType('squareup.rewards.rewardCode.service.GetForMerchantResponse');
fixType(GetForMerchantResponse);
Builder.createAndAttachToType(GetForMerchantResponse);
/**
 * SOURCE Status @ squareup/rewards/rewardCode/service.proto at 193:3
 */
GetForMerchantResponse.Status = $root.lookupEnum('squareup.rewards.rewardCode.service.GetForMerchantResponse.Status').values;
/**
 * SOURCE CustomizeRewardCodeRequest @ squareup/rewards/rewardCode/service.proto at 219:1
 */
export const CustomizeRewardCodeRequest = $root.lookupType('squareup.rewards.rewardCode.service.CustomizeRewardCodeRequest');
fixType(CustomizeRewardCodeRequest);
Builder.createAndAttachToType(CustomizeRewardCodeRequest);
/**
 * SOURCE CustomizeRewardCodeResponse @ squareup/rewards/rewardCode/service.proto at 223:1
 */
export const CustomizeRewardCodeResponse = $root.lookupType('squareup.rewards.rewardCode.service.CustomizeRewardCodeResponse');
fixType(CustomizeRewardCodeResponse);
Builder.createAndAttachToType(CustomizeRewardCodeResponse);
/**
 * SOURCE Status @ squareup/rewards/rewardCode/service.proto at 224:3
 */
CustomizeRewardCodeResponse.Status = $root.lookupEnum('squareup.rewards.rewardCode.service.CustomizeRewardCodeResponse.Status').values;
/**
 * SOURCE GetRewardCodeUsesForMerchantRequest @ squareup/rewards/rewardCode/service.proto at 248:1
 */
export const GetRewardCodeUsesForMerchantRequest = $root.lookupType('squareup.rewards.rewardCode.service.GetRewardCodeUsesForMerchantRequest');
fixType(GetRewardCodeUsesForMerchantRequest);
Builder.createAndAttachToType(GetRewardCodeUsesForMerchantRequest);
/**
 * SOURCE GetRewardCodeUsesForMerchantResponse @ squareup/rewards/rewardCode/service.proto at 252:1
 */
export const GetRewardCodeUsesForMerchantResponse = $root.lookupType('squareup.rewards.rewardCode.service.GetRewardCodeUsesForMerchantResponse');
fixType(GetRewardCodeUsesForMerchantResponse);
Builder.createAndAttachToType(GetRewardCodeUsesForMerchantResponse);
/**
 * SOURCE Status @ squareup/rewards/rewardCode/service.proto at 253:3
 */
GetRewardCodeUsesForMerchantResponse.Status = $root.lookupEnum('squareup.rewards.rewardCode.service.GetRewardCodeUsesForMerchantResponse.Status').values;
/**
 * SOURCE RewardCodeService @ squareup/rewards/rewardCode/service.proto at 14:1
 */
export const RewardCodeService = $root.lookupService('squareup.rewards.rewardCode.service.RewardCodeService');
